import React from 'react';
import { FilePlus2 } from 'lucide-react';

const WeightTagListToolbar = ({ onAdd }) => {
    return (
        <div className="sticky-top bg-light border-bottom">
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0">Weight Tags</h5>
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-primary"
                                onClick={onAdd}
                                title="Add New Weight Tag"
                            >
                                <FilePlus2 size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }

                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }

                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default WeightTagListToolbar;